import { action, observable } from 'mobx';
import { api } from '../config';

// Helpers
import { convertObjToQuery, getPath } from '../helpers/helpers';

// Components
import SessionStore from './SessionStore';

var obx = observable({
  // List blackout dates
  blackoutDatesNext: null,
  blackoutDates: [],
  listBlackoutDates: action(function(query) {
    SessionStore.startLoading('Loading…', 'listBlackoutDates');

    api.get(`/installs/${SessionStore.userData.installSid}/blackoutDates${convertObjToQuery(query)}`)
      .then(response => {
        obx.blackoutDates = response.data.results;

        // Set pagination next url
        if(response.data.next) {
          // API returns a url with a different domain for the next link
          // so create an anchor element and set its href to the next link
          // and then grab the pathname and query from that
          let nextUrl = getPath(response.data.next);
          nextUrl = nextUrl.replace('/v1', '');
          obx.blackoutDatesNext = nextUrl;
        } else {
          obx.blackoutDatesNext = null;
        }

        SessionStore.finishLoading('listBlackoutDates');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get blackout date
  blackoutDate: null,
  getBlackoutDate: action(function(blackoutDateSid, callback) {
    SessionStore.startLoading('Loading…', 'getBlackoutDate');

    api.get(`/installs/${SessionStore.userData.installSid}/blackoutDates/${blackoutDateSid}`)
      .then(response => {
        obx.blackoutDate = response.data;

        if(callback) {
          callback(response);
        }

        SessionStore.finishLoading('getBlackoutDate');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete blackout date
  deleteBlackoutDate: action(function(blackoutDateSid, callback) {
    SessionStore.startLoading('Loading…', 'deleteBlackoutDate');

    api.delete(`/installs/${SessionStore.userData.installSid}/blackoutDates/${blackoutDateSid}`)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('deleteBlackoutDate');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Create blackout date
  createBlackoutDate: action(function(data, callback) {
    SessionStore.startLoading('Loading…', 'createBlackoutDate');

    api.post(`/installs/${SessionStore.userData.installSid}/blackoutDates`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('createBlackoutDate');
      })
      .catch(error => {
        SessionStore.throwError(error)
      })
  }),
  // Update blackout date
  updateBlackoutDate: action(function(blackoutDateSid, data, callback) {
    SessionStore.startLoading('Loading…', 'updateBlackoutDate');

    api.put(`/installs/${SessionStore.userData.installSid}/blackoutDates/${blackoutDateSid}`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('updateBlackoutDate');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/BlackoutStore.js